module.exports = __webpack_public_path__ + "img/insurance-info.de3543ef.svg";